function base64toByteString(dataURI: string) {
    return atob(dataURI.split(',')[1]);
}

function getMimeFromBase64Image(dataURI: string) {
    return dataURI.split(',')[0].split(':')[1].split(';')[0];
}

export function dataURLtoBlob(dataURI: string) {
    const byteString = base64toByteString(dataURI);

    const mimeString = getMimeFromBase64Image(dataURI);

    const arrayBuffer = new ArrayBuffer(byteString.length);

    const ia = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
    }

    const dataView = new DataView(arrayBuffer);

    return new Blob([dataView.buffer], { type: mimeString });
}

export function dataToFormData(dataUrl: string, data?: Map<string, string>): FormData {
    const formData = new FormData();
    formData.append('file', dataURLtoBlob(dataUrl));

    if (data) {
        data.forEach((value, key) => {
            formData.append(key, value);
        });
    }

    return formData;
}
